<div class="row">
    <div class="col-sm-12">
        <kendo-grid #uiGrid
                    [data]="gridData"
                    [pageSize]="gridState.take"
                    [skip]="gridState.skip"
                    [sort]="gridState.sort"
                    [filter]="gridState.filter"
                    [sortable]="true"
                    [pageable]="true"
                    [filterable]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column field="tableName" title="Table"></kendo-grid-column>
            <kendo-grid-column field="recordId" title="Key"></kendo-grid-column>
            <kendo-grid-column field="transactionDate" title="Date">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.transactionDate | date: 'M/dd/yy HH:mm'}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="employeeName" title="Employee"></kendo-grid-column>
            <kendo-grid-column field="columnName" title="Field"></kendo-grid-column>
            <kendo-grid-column field="originalValue" title="Original"></kendo-grid-column>
            <kendo-grid-column field="newValue" title="New"></kendo-grid-column>
        </kendo-grid>
    </div>
</div>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay':isLoading}" *ngIf="isLoading">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
